import { BCMSRecord, BrandingImage, DisabledPrompt, useBCMSContext, useModel, useStateManager } from "@bcm-dev/bcms-vite";
import { PageContainer, TableBody, TableColumnContainer, TableColumnView, TableView } from 'components/shared';
import CopyrightView from 'components/shared/views/CopyrightView';
import Classes from "model";
import React from 'react';
import { ImageAsset } from 'res';
import "./styles.css";

/**
 * @function SecureMailPage
 * @return {React.Component}
 * @exported true
 * @description The Secure Mail Page
 */

export default function SecureMailPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);
  const { user } = useModel();
  const data = { ...getDefaultData(user), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: (prop, selectedWireHistory) => value => {
        
      },
  });

  return(
    <PageContainer className="secure-mail-page" state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </PageContainer>
  );
}

export const getDefaultData = user => {
  
  return {
    user: user ?? { first: "George", last: "Washington" }
  }
};
export const getDefaultUI = () => ({
  // no ui changes for now
});

function PageContent(props) {

  return (
    <>
      <SecureMailPageHeaderView />
      {/* Tabs */}
      <div className="tabs-container flex-container flex-horizontal">
        <div className="left-tabs flex-container flex-horizontal flex-width">
          <div className="tab inbox-tab active-tab">
            <p>Inbox</p>
          </div>
          <DisabledPrompt>
            <div className="tab sent-tab clickable">
              <p>Sent</p>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="tab trash-tab clickable">
              <p>Trash</p>
            </div>
          </DisabledPrompt>
          <DisabledPrompt>
            <div className="tab compose-tab clickable">
              <p>Compose</p>
            </div>
          </DisabledPrompt>
        </div>
        <div className="right-tabs set-width">
          <DisabledPrompt>
            <div className="tab options-tab clickable">
              <p>Options</p>
            </div>
          </DisabledPrompt>
        </div>
      </div>

      <div className="secure-mail-page-content">
        {/* Table Content */}
        <TableView>
          <TableColumnContainer>
            <TableColumnView className="v-column" text={<DisabledPrompt><button className="v-button clickable">v</button></DisabledPrompt>} />
            <TableColumnView text="From" />
            <TableColumnView text="To" />
            <TableColumnView text="Subject" />
            <TableColumnView text="Date" />
            <TableColumnView text="Size" />
          </TableColumnContainer>
          <TableBody>
            <tr>
              <td className="text-center" colSpan="6">
                <div className="flex-container flex-vertical align-center empty-folder-container">
                  <b className="empty-folder-text">THIS FOLDER IS EMPTY</b>
                  <DisabledPrompt>
                    <button className="delete-button clickable">Delete Folder</button>
                  </DisabledPrompt>
                </div>
              </td>
            </tr>
          </TableBody>
          
        </TableView>
      </div>
      <SecureMailPageFooterView />
    </>
  )
}

/**
 * @function SecureMailPageHeaderView
 * @return {React.Component}
 * @exported false
 * @description The header that shows on the SecureMailPage page
 */

function SecureMailPageHeaderView(props) {
  const { data } = useStateManager();
  const { user } = data;
  return(
    <div className="secure-mail-page-header-view flex-container flex-horizontal space-between">
        <BrandingImage id="header_logo_abi22" className="logo" />
        <div className="right-container flex-container flex-horizontal align-center">
          <p className="username">{ `${ user.first } ${ user.last }` }</p>
          <DisabledPrompt>
            <div className="sign-out-button flex-container flex-horizontal align-center clickable">
              <ImageAsset id="SignOutIcon" className="sign-out-icon inline-text-icon left-icon" />
              <p>Sign Out</p>
            </div>
          </DisabledPrompt>
        </div>
    </div>
  );
}

/**
 * @function SecureMailPageFooterView
 * @return {React.Component}
 * @exported false
 * @description The footer for SecureMailPage
 */

function SecureMailPageFooterView(props){
  return(
    <div className="secure-mail-page-footer-view flex-container">
      <CopyrightView/>
    </div>
  );
}